export default "__VITE_ASSET__CHjNGinM__"